import { ord } from 'fp-ts';
import { createSelector } from 'reselect';
import { ResourceOccupancyState } from '@mews-commander/data-access';
import { getResourceIdOrd } from '@mews-commander/legacy-entities/src/ducks/spaces';

export const getResourceOccupancyStateOrd = createSelector(
    getResourceIdOrd,
    ord.contramap(({ resourceId }: ResourceOccupancyState) => resourceId)
);
